import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { companyApi } from './api';
import companyQueryKey from './companyQueryKey';

export default function useEcommerceReportMutation(domain: string): UseMutationResult<void, void, string> {
  const queryClient = useQueryClient();

  const postEcommerceReport = async () => await companyApi.reportEcommerceOverview(domain);

  const handleQuerySuccess = () => {
    queryClient.setQueryData(companyQueryKey.ecommerceReportStatus(domain), { isEcommerceReported: true });
  };

  return useMutation({
    mutationFn: postEcommerceReport,
    retry: false,
    throwOnError: true,
    onSuccess: handleQuerySuccess,
  });
}
